(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.dataset.csInit === 'true') return;
      root.dataset.csInit = 'true';

      var track = root.querySelector('[data-cs-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cs-slide]'));
      if (slides.length < 2) return;

      var prev = root.querySelector('[data-cs-prev]');
      var next = root.querySelector('[data-cs-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cs-dot]'));
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      function setActive(i) {
        current = i;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
        dots.forEach(function (dot, di) {
          var active = di === i;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      dots.forEach(function (dot, di) {
        dot.addEventListener('click', function () { goTo(di); });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = slides.indexOf(entry.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (slide) { io.observe(slide); });
      } else {
        track.addEventListener('scroll', function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      }

      setActive(0);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-category-slider]').forEach(initSlider);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout-prototype"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCheckoutPrototype(scope) {
      const context = scope && scope.querySelector ? scope : document;
      const root =
        (context.matches && context.matches('[data-checkout-prototype]'))
          ? context
          : context.querySelector('[data-checkout-prototype]');
      if (!root || root.dataset.checkoutPrototypeReady === 'true') return;

      const form = root.querySelector('[data-checkout-prototype-form]');
      if (!form) return;

      root.dataset.checkoutPrototypeReady = 'true';

      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const submitButton = form.querySelector('[data-checkout-prototype-submit]');
      const statusEl = form.querySelector('[data-checkout-prototype-status]');
      const deliveryFieldsets = form.querySelectorAll('[data-method-fields="delivery"]');
      const deliveryMethodInputs = form.querySelectorAll('[data-delivery-method-option]');
      const subtotalEl = root.querySelector('[data-checkout-subtotal]');
      const totalEl = root.querySelector('[data-checkout-total]');
      const deliveryRow = root.querySelector('[data-checkout-delivery-row]');
      const deliveryLabelEl = root.querySelector('[data-checkout-delivery-label]');
      const deliveryValueEl = root.querySelector('[data-checkout-delivery-value]');
      const deliveryHelperEl = root.querySelector('[data-checkout-delivery-helper]');
      const itemsListEl = root.querySelector('[data-checkout-items]');

      const DELIVERY_FEE = Number.parseInt(root.dataset.deliveryFee, 10) || 2500;
      const LABEL_DELIVERY = root.dataset.labelDelivery || '';
      const LABEL_PICKUP = root.dataset.labelPickup || '';
      const QUANTITY_LABEL_TEMPLATE = root.dataset.quantityLabel || 'Qty ';
      const strings = (window.theme && window.theme.checkoutPrototypeStrings) || {};

      let selectedDeliveryMethod = 'delivery';

      function readSelectedDeliveryMethod() {
        const checked = [...deliveryMethodInputs].find((input) => input.checked);
        selectedDeliveryMethod = checked && checked.value === 'pickup' ? 'pickup' : 'delivery';
        return selectedDeliveryMethod;
      }

      function getDeliveryMethod() {
        return selectedDeliveryMethod;
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
        }
        return (cents / 100).toFixed(2);
      }

      function escapeHtml(value) {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function quantityLabel(quantity) {
        return QUANTITY_LABEL_TEMPLATE.replace(/\{\{\s*quantity\s*\}\}/g, quantity);
      }

      function renderCartItems(cart) {
        if (!itemsListEl) return;

        if (!cart || !cart.items || !cart.items.length) {
          itemsListEl.innerHTML = '';
          return;
        }

        itemsListEl.innerHTML = cart.items
          .map((item) => {
            const title = escapeHtml(item.product_title || item.title || '');
            const url = escapeHtml(item.url || '#');
            const variant =
              item.variant_title && item.variant_title !== 'Default Title'
                ? '<p class="checkout-prototype__item-variant">' +
                  escapeHtml(item.variant_title) +
                  '</p>'
                : '';
            const imageMarkup = item.image
              ? '<img class="checkout-prototype__item-image" src="' +
                escapeHtml(item.image) +
                '" alt="" loading="lazy" width="72" height="90">'
              : '<div class="checkout-prototype__item-placeholder" aria-hidden="true"></div>';

            return (
              '<li class="checkout-prototype__item">' +
              '<a class="checkout-prototype__item-media" href="' +
              url +
              '">' +
              imageMarkup +
              '</a>' +
              '<div class="checkout-prototype__item-details">' +
              '<a class="checkout-prototype__item-title" href="' +
              url +
              '">' +
              title +
              '</a>' +
              variant +
              '<p class="checkout-prototype__item-meta">' +
              escapeHtml(quantityLabel(item.quantity)) +
              ' · ' +
              escapeHtml(formatMoney(item.final_line_price)) +
              '</p>' +
              '</div>' +
              '</li>'
            );
          })
          .join('');
      }

      function renderDeliverySummary(method) {
        if (!deliveryRow || !deliveryValueEl || !deliveryHelperEl) return;

        const isPickup = method === 'pickup';
        const fee = isPickup ? 0 : DELIVERY_FEE;

        if (deliveryLabelEl) {
          deliveryLabelEl.textContent = isPickup ? LABEL_PICKUP : LABEL_DELIVERY;
        }

        deliveryRow.hidden = false;
        deliveryValueEl.innerHTML =
          '<span class="checkout-prototype__delivery-fee">' + formatMoney(fee) + '</span>';
        deliveryHelperEl.hidden = false;
        deliveryHelperEl.textContent = isPickup
          ? strings.pickupFree || ''
          : strings.deliveryWarsawNote || '';

        return fee;
      }

      function recalculateOrderSummary(cart) {
        const subtotalCents =
          cart && typeof cart.total_price === 'number'
            ? cart.total_price
            : Number.parseInt(root.dataset.cartSubtotal, 10) || 0;

        root.dataset.cartSubtotal = String(subtotalCents);

        const method = getDeliveryMethod();
        const fee = renderDeliverySummary(method);

        if (subtotalEl) subtotalEl.textContent = formatMoney(subtotalCents);
        if (totalEl) totalEl.textContent = formatMoney(subtotalCents + fee);
      }

      function updateSummary(cart) {
        renderCartItems(cart);
        recalculateOrderSummary(cart);
      }

      async function refreshSummaryFromCart() {
        try {
          const response = await fetch(rootPath + 'cart.js', {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const cart = await response.json();
          readSelectedDeliveryMethod();
          updateSummary(cart);
        } catch (error) {
          console.error(error);
        }
      }

      function toggleMethodField(field, show) {
        field.hidden = !show;
        field.disabled = !show;
      }

      function applyMethodVisibility() {
        const isPickup = selectedDeliveryMethod === 'pickup';
        deliveryFieldsets.forEach((field) => toggleMethodField(field, !isPickup));
      }

      function onDeliveryMethodChange(event) {
        selectedDeliveryMethod = event.target.value === 'pickup' ? 'pickup' : 'delivery';
        applyMethodVisibility();
        refreshSummaryFromCart();
      }

      readSelectedDeliveryMethod();

      deliveryMethodInputs.forEach((input) => {
        input.addEventListener('change', onDeliveryMethodChange);
      });

      applyMethodVisibility();
      refreshSummaryFromCart();

      document.addEventListener('cart:updated', (event) => {
        if (event.detail && event.detail.cart) {
          readSelectedDeliveryMethod();
          updateSummary(event.detail.cart);
        }
      });

      window.addEventListener('focus', refreshSummaryFromCart);

      const dateInputs = [...form.querySelectorAll('[data-order-date]')];
      const timeSlotSelect = form.querySelector('[data-time-slot]');
      const timeSlotError = form.querySelector('[data-time-slot-error]');
      const TIME_SLOT_LEAD_MINUTES = 120;

      // Current date/time in the Europe/Warsaw timezone, independent of the
      // visitor's device timezone.
      function getWarsawNow() {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Warsaw',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).formatToParts(new Date());

        const lookup = {};
        parts.forEach((part) => {
          lookup[part.type] = part.value;
        });

        let hour = parseInt(lookup.hour, 10);
        if (hour === 24 || Number.isNaN(hour)) hour = 0;
        const minute = parseInt(lookup.minute, 10) || 0;

        return {
          date: lookup.year + '-' + lookup.month + '-' + lookup.day,
          minutes: hour * 60 + minute,
        };
      }

      function todayString() {
        return getWarsawNow().date;
      }

      function slotStartMinutes(option) {
        const raw = (option.dataset.slotStart || '').split(':');
        const hours = parseInt(raw[0], 10) || 0;
        const minutes = parseInt(raw[1], 10) || 0;
        return hours * 60 + minutes;
      }

      function updateTimeSlots() {
        if (!timeSlotSelect) return;

        const warsaw = getWarsawNow();
        const selectedDate = dateInputs.length ? dateInputs[0].value : '';
        const isToday = selectedDate !== '' && selectedDate === warsaw.date;
        const isPast = selectedDate !== '' && selectedDate < warsaw.date;
        const cutoff = warsaw.minutes + TIME_SLOT_LEAD_MINUTES;

        const options = [...timeSlotSelect.querySelectorAll('option[data-slot-start]')];
        let availableCount = 0;

        options.forEach((option) => {
          let disabled = false;
          if (isPast) {
            disabled = true;
          } else if (isToday) {
            disabled = slotStartMinutes(option) < cutoff;
          }
          option.disabled = disabled;
          if (!disabled) availableCount += 1;
        });

        // Reset to the placeholder if the previously chosen slot is no longer valid.
        const current = timeSlotSelect.selectedOptions[0];
        if (current && current.disabled) {
          timeSlotSelect.selectedIndex = 0;
        }

        if (timeSlotError) {
          const showMessage = isToday && availableCount === 0;
          timeSlotError.hidden = !showMessage;
          timeSlotError.textContent = showMessage ? timeSlotError.dataset.message || '' : '';
        }
      }

      function dateErrorFor(input) {
        const field = input.closest('.checkout-prototype__field');
        return field ? field.querySelector('[data-order-date-error]') : null;
      }

      function clearDateError(input) {
        input.setCustomValidity('');
        input.classList.remove('checkout-prototype__input--error');
        const dateError = dateErrorFor(input);
        if (dateError) dateError.hidden = true;
      }

      function showDateError(input) {
        const dateError = dateErrorFor(input);
        const message =
          (dateError && dateError.dataset.message) || strings.deliveryDateError || '';
        input.setCustomValidity(message);
        input.classList.add('checkout-prototype__input--error');
        if (dateError) {
          dateError.textContent = message;
          dateError.hidden = false;
        }
      }

      function validateDate() {
        const today = todayString();
        let valid = true;
        dateInputs.forEach((input) => {
          if (input.disabled) {
            clearDateError(input);
            return;
          }
          if (input.value && input.value < today) {
            showDateError(input);
            valid = false;
          } else {
            clearDateError(input);
          }
        });
        return valid;
      }

      dateInputs.forEach((input) => {
        const today = todayString();
        input.min = today;
        if (!input.value || input.value < today) {
          input.value = today;
        }
        input.addEventListener('change', () => {
          validateDate();
          updateTimeSlots();
        });
        input.addEventListener('input', () => {
          clearDateError(input);
          updateTimeSlots();
        });
      });

      // Initial availability check on page load.
      updateTimeSlots();

      const giftToggle = form.querySelector('[data-gift-toggle]');
      const giftPanel = form.querySelector('[data-gift-panel]');
      const giftFieldset = giftToggle ? giftToggle.closest('[data-gift]') : null;

      function syncGift() {
        if (!giftToggle) return;
        const on = giftToggle.checked;
        giftToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (giftPanel) giftPanel.classList.toggle('is-expanded', on);
        if (giftFieldset) giftFieldset.classList.toggle('is-active', on);
      }

      if (giftToggle) {
        giftToggle.addEventListener('change', syncGift);
        syncGift();
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        validateDate();
        updateTimeSlots();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        submitButton && submitButton.classList.add('checkout-prototype__button--loading');

        const formData = new FormData(form);
        const payload = {
          note: formData.get('note') || '',
          attributes: {
            delivery_method: getDeliveryMethod(),
            delivery_date: formData.get('attributes[delivery_date]') || '',
            delivery_time_slot: formData.get('attributes[delivery_time_slot]') || '',
            order_notes: formData.get('attributes[order_notes]') || '',
          },
        };

        try {
          const updateResponse = await fetch(rootPath + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!updateResponse.ok) {
            throw new Error('Cart update failed');
          }

          if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent =
              strings.redirecting ||
              strings.saved ||
              'Order details saved. Redirecting to secure checkout...';
            statusEl.className = 'checkout-prototype__status';
          }

          window.location.href = '/checkout';
        } catch (error) {
          console.error(error);
          if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent =
              strings.error || 'Could not save your order details. Please try again.';
            statusEl.className = 'checkout-prototype__status checkout-prototype__status--error';
          }
          submitButton && submitButton.classList.remove('checkout-prototype__button--loading');
        }
      });
    }

    function boot() {
      initCheckoutPrototype(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCheckoutPrototype(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const pages = document.querySelectorAll('[data-collection-page]');
    if (!pages.length) return;

    pages.forEach((page) => {
      const chips = [...page.querySelectorAll('[data-filter-type]')];
      const clearButton = page.querySelector('[data-filter-clear]');
      const gridItems = [...page.querySelectorAll('[data-collection-grid-item]')];
      const noResults = page.querySelector('[data-collection-no-results]');
      const activeFilters = {};

      function cardMatches(card) {
        const priceTier = card.dataset.priceTier;
        const tags = (card.dataset.productTags || '').split('|').filter(Boolean);

        for (const [group, values] of Object.entries(activeFilters)) {
          if (!values.length) continue;

          if (group === 'price') {
            if (!values.includes(priceTier)) return false;
            continue;
          }

          const hasTagMatch = values.some((value) => tags.includes(value));
          if (!hasTagMatch) return false;
        }

        return true;
      }

      function applyFilters() {
        let visibleCount = 0;

        gridItems.forEach((item) => {
          const card = item.querySelector('[data-product-card]');
          if (!card) return;

          const visible = cardMatches(card);
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        const hasActiveFilters = Object.values(activeFilters).some((values) => values.length > 0);

        if (clearButton) {
          clearButton.hidden = !hasActiveFilters;
        }

        if (noResults) {
          noResults.hidden = visibleCount > 0 || gridItems.length === 0;
        }
      }

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const type = chip.dataset.filterType;
          const value = chip.dataset.filterValue;

          if (!activeFilters[type]) {
            activeFilters[type] = [];
          }

          const index = activeFilters[type].indexOf(value);

          if (index >= 0) {
            activeFilters[type].splice(index, 1);
            chip.classList.remove('collection-page__filter-chip--active');
          } else {
            activeFilters[type].push(value);
            chip.classList.add('collection-page__filter-chip--active');
          }

          applyFilters();
        });
      });

      clearButton?.addEventListener('click', () => {
        Object.keys(activeFilters).forEach((key) => {
          activeFilters[key] = [];
        });

        chips.forEach((chip) => {
          chip.classList.remove('collection-page__filter-chip--active');
        });

        applyFilters();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-contact-widget"]) return;
  try {
    
  (function () {
    var instances = new Map();

    function collectRoots(scope) {
      var scopeEl = scope || document;
      var found = [];

      if (scopeEl.nodeType === 1 && scopeEl.matches && scopeEl.matches('[data-floating-contact-widget]')) {
        found.push(scopeEl);
      }

      if (scopeEl.querySelectorAll) {
        Array.prototype.forEach.call(scopeEl.querySelectorAll('[data-floating-contact-widget]'), function (el) {
          found.push(el);
        });
      }

      return found;
    }

    function FloatingContactWidget(root) {
      this.root = root;
      this.toggle = root.querySelector('[data-fcw-toggle]');
      this.panel = root.querySelector('[data-fcw-panel]');

      if (!this.toggle || !this.panel) {
        this.destroyed = true;
        return;
      }

      this.open = false;
      this.closeTimeout = null;

      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleTransitionEnd = this.handleTransitionEnd.bind(this);

      this.toggle.addEventListener('click', this.handleToggleClick);
      document.addEventListener('keydown', this.handleDocumentKeydown);
      document.addEventListener('click', this.handleDocumentClick);
      this.panel.addEventListener('transitionend', this.handleTransitionEnd);

      this.destroyed = false;
    }

    FloatingContactWidget.prototype.handleToggleClick = function (event) {
      event.stopPropagation();
      if (this.open) {
        this.close();
      } else {
        this.openPanel();
      }
    };

    FloatingContactWidget.prototype.openPanel = function () {
      if (this.open) return;
      this.open = true;

      window.clearTimeout(this.closeTimeout);
      this.panel.hidden = false;

      // Force reflow so the opening transition runs from the closed state.
      void this.panel.offsetHeight;

      this.panel.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.closeLabel || this.toggle.getAttribute('aria-label'));
    };

    FloatingContactWidget.prototype.close = function (options) {
      if (!this.open) return;
      this.open = false;

      this.panel.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.openLabel || this.toggle.getAttribute('aria-label'));

      var self = this;
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = window.setTimeout(function () {
        if (!self.open) {
          self.panel.hidden = true;
        }
      }, 220);

      if (options && options.returnFocus) {
        this.toggle.focus();
      }
    };

    FloatingContactWidget.prototype.handleTransitionEnd = function (event) {
      if (event.target !== this.panel) return;
      if (!this.open) {
        this.panel.hidden = true;
      }
    };

    FloatingContactWidget.prototype.handleDocumentKeydown = function (event) {
      if (event.key !== 'Escape' || !this.open) return;
      this.close({ returnFocus: true });
    };

    FloatingContactWidget.prototype.handleDocumentClick = function (event) {
      if (!this.open) return;
      if (this.root.contains(event.target)) return;
      this.close();
    };

    FloatingContactWidget.prototype.destroy = function () {
      this.destroyed = true;
      window.clearTimeout(this.closeTimeout);

      if (this.toggle) {
        this.toggle.removeEventListener('click', this.handleToggleClick);
      }
      if (this.panel) {
        this.panel.removeEventListener('transitionend', this.handleTransitionEnd);
      }
      document.removeEventListener('keydown', this.handleDocumentKeydown);
      document.removeEventListener('click', this.handleDocumentClick);
    };

    function initRoot(root) {
      var id = root.dataset.sectionId;
      if (!id) return;

      var existing = instances.get(id);
      if (existing) {
        existing.destroy();
        instances.delete(id);
      }

      var instance = new FloatingContactWidget(root);
      if (!instance.destroyed) {
        instances.set(id, instance);
      }
    }

    function initAll(scope) {
      collectRoots(scope).forEach(initRoot);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var instance = instances.get(id);
      if (instance) {
        instance.destroy();
        instances.delete(id);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new Map();

    function collectRoots(scope) {
      var scopeEl = scope || document;
      var found = [];

      if (scopeEl.nodeType === 1 && scopeEl.matches && scopeEl.matches('[data-google-reviews]')) {
        found.push(scopeEl);
      }

      if (scopeEl.querySelectorAll) {
        Array.prototype.forEach.call(scopeEl.querySelectorAll('[data-google-reviews]'), function (el) {
          found.push(el);
        });
      }

      return found;
    }

    function createClone(li) {
      var clone = li.cloneNode(true);

      clone.removeAttribute('data-gr-slide');

      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-shopify') === 0) {
          clone.removeAttribute(attr.name);
        }
      });

      clone.setAttribute('aria-hidden', 'true');

      Array.prototype.forEach.call(clone.querySelectorAll('a, button, [tabindex]'), function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });

      return clone;
    }

    function GoogleReviewsCarousel(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-gr-viewport]');
      this.track = root.querySelector('[data-gr-track]');
      this.playPauseButton = root.querySelector('[data-gr-playpause]');
      this.playPauseLabel = root.querySelector('[data-gr-playpause-label]');

      if (!this.viewport || !this.track) {
        this.destroyed = true;
        return;
      }

      this.originalSlides = Array.prototype.slice.call(this.track.children);
      this.scrollDuration = parseFloat(root.dataset.scrollDuration) || 40;
      this.pauseOnHover = root.dataset.pauseOnHover === 'true';

      this.mql = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion = this.mql.matches;

      this.cloneEls = [];
      this.offset = 0;
      this.setWidth = 0;
      this.rafId = null;
      this.lastTime = null;
      this.resizeTimeout = null;

      this.stickyPaused = false;
      this.hoverPaused = false;
      this.focusPaused = false;
      this.selectPaused = false;
      this.dragging = false;
      this.dragAxis = null;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.dragStartOffset = 0;
      this.dragPointerId = null;

      this.destroyed = false;

      this.handleMotionChange = this.handleMotionChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this);
      this.tick = this.tick.bind(this);

      this.setup();
    }

    GoogleReviewsCarousel.prototype.setup = function () {
      if (typeof this.mql.addEventListener === 'function') {
        this.mql.addEventListener('change', this.handleMotionChange);
      } else if (typeof this.mql.addListener === 'function') {
        this.mql.addListener(this.handleMotionChange);
      }

      // Interactive listeners are bound once, unconditionally, regardless of
      // prefers-reduced-motion. Each handler already no-ops appropriately
      // when this.reducedMotion is true, so only the autoplay/animation
      // effects below (buildClones + start) are gated on that flag.
      window.addEventListener('resize', this.handleResize);
      this.track.addEventListener('pointerdown', this.handlePointerDown);
      this.root.addEventListener('mouseenter', this.handleMouseEnter);
      this.root.addEventListener('mouseleave', this.handleMouseLeave);
      this.root.addEventListener('focusin', this.handleFocusIn);
      this.root.addEventListener('focusout', this.handleFocusOut);

      if (this.playPauseButton) {
        this.playPauseButton.addEventListener('click', this.handlePlayPauseClick);
        this.updatePlayPauseUI();
      }

      if (this.reducedMotion) {
        return;
      }

      this.buildClones();
      this.start();
    };

    GoogleReviewsCarousel.prototype.measureSetWidth = function () {
      var styles = getComputedStyle(this.track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var width = 0;

      this.originalSlides.forEach(function (slide) {
        width += slide.getBoundingClientRect().width + gap;
      });

      return width;
    };

    GoogleReviewsCarousel.prototype.buildClones = function () {
      this.removeClones();

      var viewportWidth = this.viewport.clientWidth || this.root.clientWidth || 0;
      this.setWidth = this.measureSetWidth();

      if (!this.setWidth || !this.originalSlides.length) {
        return;
      }

      var targetWidth = viewportWidth * 3;
      var iterations = 0;

      while (this.track.scrollWidth < targetWidth && iterations < 20) {
        this.originalSlides.forEach(
          function (slide) {
            var clone = createClone(slide);
            this.track.appendChild(clone);
            this.cloneEls.push(clone);
          }.bind(this)
        );
        iterations += 1;
      }

      if (this.setWidth) {
        this.offset = this.offset % this.setWidth;
      } else {
        this.offset = 0;
      }

      this.applyTransform();
    };

    GoogleReviewsCarousel.prototype.removeClones = function () {
      this.cloneEls.forEach(function (el) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
      this.cloneEls = [];
    };

    GoogleReviewsCarousel.prototype.start = function () {
      if (this.rafId || this.reducedMotion) {
        return;
      }
      this.lastTime = null;
      this.rafId = requestAnimationFrame(this.tick);
    };

    GoogleReviewsCarousel.prototype.stopRaf = function () {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      this.lastTime = null;
    };

    GoogleReviewsCarousel.prototype.isPaused = function () {
      return this.stickyPaused || this.hoverPaused || this.focusPaused || this.selectPaused || this.dragging;
    };

    GoogleReviewsCarousel.prototype.tick = function (timestamp) {
      if (this.destroyed) {
        return;
      }

      if (this.isPaused() || !this.setWidth) {
        this.lastTime = timestamp;
        this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      if (this.lastTime === null) {
        this.lastTime = timestamp;
      }

      var delta = timestamp - this.lastTime;
      this.lastTime = timestamp;

      var pxPerMs = this.setWidth / (this.scrollDuration * 1000);
      this.offset += pxPerMs * delta;

      if (this.offset >= this.setWidth) {
        this.offset -= this.setWidth;
      }

      this.applyTransform();
      this.rafId = requestAnimationFrame(this.tick);
    };

    GoogleReviewsCarousel.prototype.applyTransform = function () {
      this.track.style.transform = 'translate3d(-' + this.offset + 'px, 0, 0)';
    };

    GoogleReviewsCarousel.prototype.handlePointerDown = function (event) {
      if (this.reducedMotion) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = true;
      this.dragAxis = null;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.dragStartOffset = this.offset;
      this.dragPointerId = event.pointerId;

      if (this.track.setPointerCapture) {
        try {
          this.track.setPointerCapture(event.pointerId);
        } catch (error) {
          /* ignore */
        }
      }

      this.track.addEventListener('pointermove', this.handlePointerMove);
      this.track.addEventListener('pointerup', this.handlePointerUp);
      this.track.addEventListener('pointercancel', this.handlePointerUp);
    };

    GoogleReviewsCarousel.prototype.handlePointerMove = function (event) {
      if (!this.dragging) return;

      var deltaX = event.clientX - this.dragStartX;
      var deltaY = event.clientY - this.dragStartY;

      if (this.dragAxis === null) {
        if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
        this.dragAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
      }

      if (this.dragAxis === 'y') return;

      if (event.cancelable) event.preventDefault();

      var newOffset = this.dragStartOffset - deltaX;
      if (this.setWidth) {
        newOffset = ((newOffset % this.setWidth) + this.setWidth) % this.setWidth;
      }
      this.offset = newOffset;
      this.applyTransform();
    };

    GoogleReviewsCarousel.prototype.handlePointerUp = function (event) {
      this.dragging = false;
      this.dragAxis = null;

      if (this.track.releasePointerCapture && this.dragPointerId !== null) {
        try {
          this.track.releasePointerCapture(this.dragPointerId);
        } catch (error) {
          /* ignore */
        }
      }

      this.dragPointerId = null;
      this.track.removeEventListener('pointermove', this.handlePointerMove);
      this.track.removeEventListener('pointerup', this.handlePointerUp);
      this.track.removeEventListener('pointercancel', this.handlePointerUp);
    };

    GoogleReviewsCarousel.prototype.handleMouseEnter = function () {
      if (this.pauseOnHover) this.hoverPaused = true;
    };

    GoogleReviewsCarousel.prototype.handleMouseLeave = function () {
      this.hoverPaused = false;
    };

    GoogleReviewsCarousel.prototype.handleFocusIn = function () {
      this.focusPaused = true;
    };

    GoogleReviewsCarousel.prototype.handleFocusOut = function () {
      var self = this;
      requestAnimationFrame(function () {
        if (self.destroyed) return;
        if (!self.root.contains(document.activeElement)) {
          self.focusPaused = false;
        }
      });
    };

    GoogleReviewsCarousel.prototype.handlePlayPauseClick = function () {
      this.stickyPaused = !this.stickyPaused;
      this.updatePlayPauseUI();
    };

    GoogleReviewsCarousel.prototype.updatePlayPauseUI = function () {
      if (!this.playPauseButton) return;

      this.playPauseButton.setAttribute('aria-pressed', String(this.stickyPaused));
      this.playPauseButton.classList.toggle('is-paused', this.stickyPaused);

      if (this.playPauseLabel) {
        var label = this.stickyPaused
          ? this.playPauseButton.dataset.resumeLabel
          : this.playPauseButton.dataset.pauseLabel;
        if (label) this.playPauseLabel.textContent = label;
      }
    };

    GoogleReviewsCarousel.prototype.setSelectPaused = function (value) {
      this.selectPaused = value;
    };

    GoogleReviewsCarousel.prototype.handleResize = function () {
      if (this.reducedMotion) return;

      var self = this;
      window.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(function () {
        if (self.destroyed) return;
        self.buildClones();
      }, 150);
    };

    GoogleReviewsCarousel.prototype.handleMotionChange = function (event) {
      this.reducedMotion = event.matches;

      // Interactive listeners (drag, hover-pause, focus-pause, play/pause
      // button) are bound once in setup() and stay bound for the lifetime of
      // the instance; only the autoplay/animation effects toggle here.
      if (this.reducedMotion) {
        this.stopRaf();
        this.removeClones();
        this.track.style.transform = '';
      } else {
        this.buildClones();
        this.start();
      }
    };

    GoogleReviewsCarousel.prototype.destroy = function () {
      this.destroyed = true;
      this.stopRaf();
      window.clearTimeout(this.resizeTimeout);
      window.removeEventListener('resize', this.handleResize);

      if (typeof this.mql.removeEventListener === 'function') {
        this.mql.removeEventListener('change', this.handleMotionChange);
      } else if (typeof this.mql.removeListener === 'function') {
        this.mql.removeListener(this.handleMotionChange);
      }

      if (this.track) {
        this.track.removeEventListener('pointerdown', this.handlePointerDown);
        this.track.removeEventListener('pointermove', this.handlePointerMove);
        this.track.removeEventListener('pointerup', this.handlePointerUp);
        this.track.removeEventListener('pointercancel', this.handlePointerUp);
        this.track.style.transform = '';
      }

      if (this.root) {
        this.root.removeEventListener('mouseenter', this.handleMouseEnter);
        this.root.removeEventListener('mouseleave', this.handleMouseLeave);
        this.root.removeEventListener('focusin', this.handleFocusIn);
        this.root.removeEventListener('focusout', this.handleFocusOut);
      }

      if (this.playPauseButton) {
        this.playPauseButton.removeEventListener('click', this.handlePlayPauseClick);
      }

      this.removeClones();
    };

    function initRoot(root) {
      var id = root.dataset.sectionId;
      if (!id) return;

      var existing = instances.get(id);
      if (existing) {
        existing.destroy();
        instances.delete(id);
      }

      var instance = new GoogleReviewsCarousel(root);
      if (!instance.destroyed) {
        instances.set(id, instance);
      }
    }

    function initAll(scope) {
      collectRoots(scope).forEach(initRoot);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var instance = instances.get(id);
      if (instance) {
        instance.destroy();
        instances.delete(id);
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      var id = event.detail && event.detail.sectionId;
      var instance = id ? instances.get(id) : null;
      if (instance) instance.setSelectPaused(true);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var id = event.detail && event.detail.sectionId;
      var instance = id ? instances.get(id) : null;
      if (instance) instance.setSelectPaused(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-wilanow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playFromStart(video) {
      try {
        video.currentTime = 0;
      } catch (error) {
        /* ignore */
      }
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* ignore */
        });
      }
    }

    function initHeroVideo(hero) {
      if (!hero || hero.dataset.heroVideoReady === 'true') return;
      const video = hero.querySelector('[data-hero-video]');
      if (!video) return;

      hero.dataset.heroVideoReady = 'true';
      video.muted = true;
      video.loop = false;
      video.autoplay = false;
      video.controls = false;

      // Ensure the poster/source are loaded so iOS Safari shows a real image.
      try {
        video.load();
      } catch (error) {
        /* ignore */
      }

      const prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Reduced-motion: never play, keep the poster image only.
      if (prefersReducedMotion) {
        return;
      }

      const isTouch =
        window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

      if (isTouch) {
        // Mobile / touch: play once when the hero becomes 35% visible.
        if (typeof IntersectionObserver === 'undefined') {
          playFromStart(video);
          return;
        }

        let hasPlayed = false;
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (hasPlayed) return;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                hasPlayed = true;
                playFromStart(video);
                observer.disconnect();
              }
            });
          },
          { threshold: [0, 0.35, 1] }
        );
        observer.observe(hero);
        return;
      }

      // Desktop (mouse): play once per hover, from the beginning.
      let hoverPlayed = false;

      hero.addEventListener('pointerenter', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        if (hoverPlayed) return;
        hoverPlayed = true;
        playFromStart(video);
      });

      hero.addEventListener('pointerleave', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        // Keep the current (final) frame visible; only reset so the next
        // entry can play the video again from the beginning.
        hoverPlayed = false;
      });
    }

    function boot() {
      document.querySelectorAll('[data-hero-wilanow]').forEach(initHeroVideo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const hero = event.target.querySelector
        ? event.target.querySelector('[data-hero-wilanow]')
        : null;
      if (hero) initHeroVideo(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-checkout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const rootPath = window.Shopify?.routes?.root || '/';
    const form = document.querySelector('[data-order-checkout-form]');
    if (!form) return;

    const submitButton = form.querySelector('[data-order-checkout-submit]');
    const statusEl = form.querySelector('[data-order-checkout-status]');

    function showStatus(message, type) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.textContent = message;
      statusEl.className = 'order-checkout__status order-checkout__status--' + type;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submitButton?.classList.add('order-checkout__button--loading');
      submitButton.disabled = true;

      const formData = new FormData(form);
      const note = formData.get('note') || '';
      const attributes = {};

      formData.forEach((value, key) => {
        if (key.startsWith('attributes[')) {
          const attributeKey = key.replace('attributes[', '').replace(']', '');
          attributes[attributeKey] = value;
        }
      });

      try {
        const response = await fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ note, attributes }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        showStatus(
          window.theme?.orderCheckoutStrings?.saved ||
            'Order details saved. Payment integration will be connected here.',
          'success'
        );
      } catch (error) {
        console.error(error);
        showStatus(
          window.theme?.orderCheckoutStrings?.error ||
            'Could not save your order details. Please try again.',
          'error'
        );
      } finally {
        submitButton?.classList.remove('order-checkout__button--loading');
        submitButton.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function formatMoney(cents) {
      const format = window.theme && window.theme.moneyFormat;
      if (format && typeof window.Shopify?.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }

    function initProductMain(root) {
      if (root.dataset.productMainReady === 'true') return;
      root.dataset.productMainReady = 'true';

      let variants = [];
      const variantsScript = root.querySelector('[data-product-variants]');
      if (variantsScript) {
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (error) {
          console.warn('[product] could not parse variants', error);
        }
      }

      const optionInputs = root.querySelectorAll('[data-option-input]');
      const optionGroups = root.querySelectorAll('[data-option-group]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const priceEl = root.querySelector('[data-product-price]');
      const comparePriceEl = root.querySelector('[data-product-compare-price]');
      const qtyInput = root.querySelector('[data-qty-input]');
      const mainImage = root.querySelector('[data-product-main-image]');

      // Mono bouquet picker (rendered only when product.metafields.custom.mono_bouquet.value == true).
      // Reuses the same option-group / variant-matching mechanism as regular option pills;
      // see the "Mono bouquet mode" comment near the top of this file for the merchant convention.
      const monoGroup = root.querySelector('[data-mono-group]');
      const monoOptionIndex = monoGroup ? Number.parseInt(monoGroup.dataset.optionIndex, 10) : -1;
      const monoButtons = monoGroup ? [...monoGroup.querySelectorAll('[data-mono-value]')] : [];

      const strings = {
        addToCart: root.dataset.strAddToCart || 'Add to cart',
        soldOut: root.dataset.strSoldOut || 'Sold out',
        unavailable: root.dataset.strUnavailable || 'Unavailable',
      };

      function selectedOptions() {
        return [...optionGroups].map((group) => {
          if (group === monoGroup) {
            const active = monoGroup.querySelector('[data-mono-value].is-selected');
            return active ? active.dataset.monoValue : null;
          }
          const checked = group.querySelector('[data-option-input]:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(opts) {
        return variants.find(
          (variant) =>
            variant.options.length === opts.length &&
            variant.options.every((value, index) => value === opts[index])
        );
      }

      function activateThumb(thumb) {
        if (!mainImage || !thumb) return;

        const src = thumb.dataset.mediaSrc;
        const srcset = thumb.dataset.mediaSrcset;

        if (src) mainImage.src = src;
        if (srcset) {
          mainImage.setAttribute('srcset', srcset);
        } else {
          mainImage.removeAttribute('srcset');
        }
        if (thumb.dataset.mediaWidth) mainImage.setAttribute('width', thumb.dataset.mediaWidth);
        if (thumb.dataset.mediaHeight) mainImage.setAttribute('height', thumb.dataset.mediaHeight);
        if (thumb.dataset.mediaAlt) mainImage.setAttribute('alt', thumb.dataset.mediaAlt);
        if (thumb.dataset.mediaId) mainImage.dataset.mediaId = thumb.dataset.mediaId;

        root.querySelectorAll('[data-thumb]').forEach((node) => {
          const isActive = node === thumb;
          node.classList.toggle('is-active', isActive);
          node.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      // Disables mono option values that have no matching available variant given the
      // currently selected values of the *other* options. Scoped to the mono picker only;
      // regular (non-mono) option pills keep their existing behavior untouched.
      function updateMonoAvailability() {
        if (!monoGroup || monoOptionIndex < 0 || !monoButtons.length) return;

        const base = selectedOptions();

        monoButtons.forEach((button) => {
          const candidate = base.slice();
          candidate[monoOptionIndex] = button.dataset.monoValue;
          const variant = findVariant(candidate);
          const available = !!variant && variant.available;
          button.disabled = !available;
          button.classList.toggle('is-unavailable', !available);
        });
      }

      function update() {
        if (!optionGroups.length) return;

        const variant = findVariant(selectedOptions());

        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = strings.unavailable;
          return;
        }

        if (addButton) addButton.dataset.variantId = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }

        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;
        }

        if (variant.featured_image && variant.featured_image.id) {
          const targetThumb = root.querySelector(
            '[data-thumb][data-media-id="' + variant.featured_image.id + '"]'
          );
          if (targetThumb) activateThumb(targetThumb);
        }
      }

      optionInputs.forEach((input) =>
        input.addEventListener('change', () => {
          update();
          updateMonoAvailability();
        })
      );

      monoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          monoButtons.forEach((node) => {
            node.classList.remove('is-selected');
            node.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');

          update();
          updateMonoAvailability();
        });
      });

      root.addEventListener('click', (event) => {
        const decrease = event.target.closest('[data-qty-decrease]');
        const increase = event.target.closest('[data-qty-increase]');
        if ((!decrease && !increase) || !qtyInput) return;

        let value = Number.parseInt(qtyInput.value, 10) || 1;
        value += increase ? 1 : -1;
        if (value < 1) value = 1;
        qtyInput.value = value;
      });

      root.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => activateThumb(thumb));
      });

      update();
      updateMonoAvailability();
    }

    function initAll(scope) {
      const context = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
      if (typeof context.matches === 'function' && context.matches('[data-product-main]')) {
        initProductMain(context);
      }
      context.querySelectorAll('[data-product-main]').forEach(initProductMain);
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    }

    // Theme Editor re-renders sections on edit; re-initialize within the guard so
    // listeners are never duplicated on the same DOM node.
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-products-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-top-products-carousel]');

    carousels.forEach((root) => {
      const viewport = root.querySelector('[data-top-products-viewport]');
      const track = root.querySelector('[data-top-products-track]');
      const prevButton = root.querySelector('[data-top-products-prev]');
      const nextButton = root.querySelector('[data-top-products-next]');
      const progressThumb = root.querySelector('[data-top-products-progress-thumb]');

      if (!viewport || !track || !prevButton || !nextButton || !progressThumb) return;

      const getScrollStep = () => {
        const slide = track.querySelector('.top-products-carousel__slide');
        if (!slide) return 0;

        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const scrollLeft = viewport.scrollLeft;
        const hasOverflow = maxScroll > 1;

        prevButton.disabled = !hasOverflow || scrollLeft <= 1;
        nextButton.disabled = !hasOverflow || scrollLeft >= maxScroll - 1;

        if (!hasOverflow) {
          progressThumb.style.width = '100%';
          progressThumb.style.left = '0%';
          return;
        }

        const thumbWidth = (viewport.clientWidth / viewport.scrollWidth) * 100;
        const travel = 100 - thumbWidth;
        const left = (scrollLeft / maxScroll) * travel;

        progressThumb.style.width = `${thumbWidth}%`;
        progressThumb.style.left = `${left}%`;
      };

      const scrollByStep = (direction) => {
        const step = getScrollStep();
        if (!step) return;

        viewport.scrollBy({
          left: direction * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      prevButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      window.addEventListener('load', updateControls);

      updateControls();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
